import { clsx } from 'clsx';
import { FILTER_GLOW_ID } from 'game/defs/FilterGlow';
import { PATTERN_LINES_ID } from 'game/defs/PatternLines';
import { BotToolChoice, ModuleType, UseModule, determineTool } from 'game/state/BotState';
import { message } from '../Message';
import { ModuleComponentProps } from './ModuleProps';
import { AxeIcon } from './icons/AxeIcon';
import { LaserIcon } from './icons/LaserIcon';
import { WateringCanIcon } from './icons/WateringCanIcon';
import { moduleStyles } from './moduleStyles';

const advanceTool = (module: UseModule, howMany: number) => {
  const choices = Object.values(BotToolChoice);
  const i = module.config.tool ? choices.indexOf(module.config.tool) : -1;
  const choiceCount = choices.length + 1;
  const nextChoice = choices[(i + howMany + choiceCount) % choiceCount] || null;
  module.config.tool = nextChoice;
};

const renderTool = (tool: BotToolChoice): JSX.Element => {
  switch (tool) {
    case BotToolChoice.WateringCan: return <WateringCanIcon />;
    case BotToolChoice.Axe: return <AxeIcon />;
    case BotToolChoice.Laser: return <LaserIcon />;
  }
};

export const UseModuleComponent: React.FC<ModuleComponentProps<ModuleType.Use>> = ({
  module,
  bot,
  grabbing,
  onGrabStart,
}) => {
  const tool = module.config.tool || determineTool(module, bot.props.state);

  return (
    <>
      <path fill="#0071bc" d="M0.5 0.5H199.5V599.5H0.5z" />
      <path
        fill="#2e3192"
        d="M777 85.2v598H579v-598h198m1-1H578v600h200v-600z"
        transform="translate(-578 -84.2)"
      />
      <rect
        width="180"
        height="78"
        x="9.5"
        y="402.48"
        fill="none"
        stroke="#fff"
        strokeMiterlimit="10"
        opacity="0.33"
        rx="5.17"
      />
      <rect
        width="180"
        height="241"
        x="9.5"
        y="101.48"
        fill="none"
        stroke="#fff"
        strokeMiterlimit="10"
        opacity="0.33"
        rx="9.1"
      />
      <text
        fill="#fff"
        fontSize="27.77"
        transform="translate(20 390.26)"
      >
        TARGET
      </text>
      <rect
        width="180"
        height="78"
        x="9.5"
        y="400.98"
        fill="none"
        stroke="#1f1e49"
        strokeMiterlimit="10"
        rx="5.17"
      />
      <rect
        width="180"
        height="241"
        x="9.5"
        y="99.98"
        fill="none"
        stroke="#1f1e49"
        strokeMiterlimit="10"
        rx="9.1"
      />
      <path fill="#fff" d="M70 440L50 430 50 450 70 440z" />
      <text
        fill="#fff"
        fontSize="27.77"
        transform="translate(68.1 530.26)"
      >
        CMD
      </text>
      <path fill="#000" d="M20 110.48H180V270.48H20z" />
      <g filter={`url(#${FILTER_GLOW_ID})`}>
        {!module.config.tool && (
          <text transform="translate(34 144)" fontSize="22" fill="#fff8b8">AUTO</text>
        )}
        {tool && (
        <g transform="translate(100 200)">
          {renderTool(tool)}
        </g>
        )}
      </g>
      <path d="M20 110.48H180V270.48H20z" fill={`url(#${PATTERN_LINES_ID})`} />

      <text
        fill="#fff"
        fontSize="27.77"
        transform="translate(20 90.26)"
      >
        TOOL
      </text>
      <path
        fill="#fff"
        d="M624.57 107.78V121a12.88 12.88 0 01-1 5.13 13.48 13.48 0 01-7.07 7.1 13.36 13.36 0 01-10.29 0 13.08 13.08 0 01-4.22-2.86 13.64 13.64 0 01-2.83-4.24 13.06 13.06 0 01-1-5.13v-13.22h5.25V121a8 8 0 00.62 3.12 7.82 7.82 0 001.71 2.57 8.19 8.19 0 002.53 1.71 7.87 7.87 0 003.1.62 8 8 0 003.12-.62 7.83 7.83 0 004.28-4.28 8 8 0 00.62-3.12v-13.22zM649.92 107.78V113H634a2.53 2.53 0 00-1.89.77 2.57 2.57 0 00-.77 1.88 2.67 2.67 0 00.77 1.92 2.51 2.51 0 001.89.79h10.61a7.87 7.87 0 013.1.62 8.6 8.6 0 012.53 1.68 7.66 7.66 0 011.71 2.51 7.93 7.93 0 01-1.71 8.72 8 8 0 01-2.53 1.71 7.7 7.7 0 01-3.1.62h-15.97V129h15.92a2.62 2.62 0 002.71-2.72 2.56 2.56 0 00-.76-1.88 2.66 2.66 0 00-2-.77H634a7.87 7.87 0 01-3.1-.62 7.52 7.52 0 01-2.5-1.71 8.11 8.11 0 01-1.68-2.53 7.7 7.7 0 01-.62-3.1 7.62 7.62 0 01.62-3.09 7.8 7.8 0 014.18-4.19 7.87 7.87 0 013.1-.62zM674.92 124.94l3.72 3.71-1.83 1.83a13.22 13.22 0 01-18.75 0 12.56 12.56 0 01-2.89-4.39 13.7 13.7 0 01-.94-5 13.56 13.56 0 01.94-5 12.63 12.63 0 012.89-4.36 12.93 12.93 0 014.39-2.92 13.29 13.29 0 0110 0 12.93 12.93 0 014.39 2.92l1.83 1.83L664 128.3a7.83 7.83 0 009.13-1.53zm-13.14-9.49a7.89 7.89 0 00-1.54 9.13l2.15-2.15 3.07-3.06c1.08-1.08 2.12-2.12 3.12-3.1s1.78-1.75 2.33-2.3a7.9 7.9 0 00-4.74-.76 7.51 7.51 0 00-4.39 2.24z"
        transform="translate(-578 -84.2)"
      />
      <rect
        width="161"
        height="51"
        x="19.5"
        y="281.98"
        fill="#ccc6be"
        rx="2.5"
      />
      <path
        fill="#d1cbc5"
        d="M756 366.68a2 2 0 012 2v46a2 2 0 01-2 2H600a2 2 0 01-2-2v-46a2 2 0 012-2h156m0-1H600a3 3 0 00-3 3v46a3 3 0 003 3h156a3 3 0 003-3v-46a3 3 0 00-3-3z"
        transform="translate(-578 -84.2)"
      />
      <rect
        width="161"
        height="51"
        x="19.5"
        y="278.98"
        fill="#fff"
        rx="2.5"
      />
      <path
        fill="#edeae6"
        d="M756 363.68a2 2 0 012 2v46a2 2 0 01-2 2H600a2 2 0 01-2-2v-46a2 2 0 012-2h156m0-1H600a3 3 0 00-3 3v46a3 3 0 003 3h156a3 3 0 003-3v-46a3 3 0 00-3-3z"
        transform="translate(-578 -84.2)"
      />
      <path
        fill="#333"
        d="M61.5 316.46L61.49 292.48 49.49 304.48 61.49 316.48"
        opacity="0.8"
      />
      <path
        fill="#333"
        d="M138.49 292.5L138.5 316.49 150.5 304.49 138.5 292.49"
        opacity="0.8"
      />
      <path
        fill="none"
        stroke="#b7b3ae"
        strokeMiterlimit="10"
        d="M99.5 279.48L99.5 333.48"
      />
      <path
        fill="#ff1d25"
        d="M150 0.48L130 0.48 110 60.48 130 60.48 150 0.48z"
      />
      <path
        fill="#f2f2f2"
        d="M180 0.48L160 0.48 140 60.48 160 60.48 180 0.48z"
      />
      <path
        fill="#ff931e"
        d="M190 60.48L200 30.48 200 0.48 190 0.48 170 60.48 190 60.48z"
      />
      <path fill="#fff" d="M150 560L130 550 130 570 150 560z" />
      <circle cx="100" cy="560" r="19.5" fill="#ff931e" />
      <path
        fill="#f15a24"
        d="M678 625.2a19 19 0 11-19 19 19 19 0 0119-19m0-1a20 20 0 1020 20 20 20 0 00-20-20z"
        transform="translate(-578 -84.2)"
      />
      <g fill="#fff" opacity="0.75">
        <circle cx="100" cy="561" r="9.5" />
        <path
          d="M678 636.2a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
          transform="translate(-578 -84.2)"
        />
      </g>
      <circle cx="100" cy="560" r="9.5" />
      <path
        fill="#f15a24"
        d="M678 635.2a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
        transform="translate(-578 -84.2)"
      />
      <circle cx="100" cy="440" r="19.5" fill="#ff1d25" />
      <path
        fill="#c1272d"
        d="M678 505.2a19 19 0 11-19 19 19 19 0 0119-19m0-1a20 20 0 1020 20 20 20 0 00-20-20z"
        transform="translate(-578 -84.2)"
      />
      <g fill="#fff" opacity="0.75">
        <circle cx="100" cy="441" r="9.5" />
        <path
          d="M678 516.2a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
          transform="translate(-578 -84.2)"
        />
      </g>
      <circle cx="100" cy="440" r="9.5" />
      <path
        fill="#c1272d"
        d="M678 515.2a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
        transform="translate(-578 -84.2)"
      />

      <rect
        className={clsx(moduleStyles.grab, { [moduleStyles.grabbing]: grabbing })}
        width={200}
        height={600}
        onMouseDown={onGrabStart}
      />
      <rect
        className={moduleStyles.hitBox}
        x={20}
        y={280}
        width={80}
        height={50}
        onClick={() => advanceTool(module, -1)}
        tabIndex={0}
        role="button"
        aria-label={message('Previous')}
      />
      <rect
        className={moduleStyles.hitBox}
        x={100}
        y={280}
        width={80}
        height={50}
        onClick={() => advanceTool(module, 1)}
        tabIndex={0}
        role="button"
        aria-label={message('Next')}
      />
    </>
  );
};
